import { all, call, fork, put, takeLatest, select } from "redux-saga/effects";
import OrdersActions, { OrdersTypes } from '../redux/Orders';
import MessageActions from "../redux/Messages";
import AuthActions from "../redux/Auth";
import UserActions from "../redux/User";
import { 
  getOrdersRequest,
  addOrderRequest,
  deleteOrderRequest,
  changeOrderStatusRequest
} from "../services/Orders";
import { userInfo } from "os";

function* getOrders({status}) {
  try {
    yield put(AuthActions.showAuthLoader())
    const { user: { id } } = yield select(state => state.user);
    const orders = yield call(getOrdersRequest, id, status);
    yield put(AuthActions.hideAuthLoader())
    yield put(OrdersActions.getOrdersDone(orders))
  } catch (error) {
    yield put(OrdersActions.getOrdersError(error))
  }
}

function* addOrder({ order, history }) {
  yield put(AuthActions.showAuthLoader())
  const { user: { id, rol } } = yield select(state => state.user);
  yield call(addOrderRequest, id, order);
  yield put(AuthActions.hideAuthLoader());
  yield put(MessageActions.showMessage('Orden creada con exito', false));
  yield put(MessageActions.hideMessage());
  rol === 'major' ? history.push('/mayorDashboard/ordersList') : history.push('/clientDashboard/ordersList')
}

function* deleteOrder({ productId, majorId }) {
  let user = yield call(deleteOrderRequest, productId, majorId);
  if(user != null) {
    yield put(UserActions.setUserData(user));
    yield put(MessageActions.showMessage('Orden eliminada con exito', false));
  }
  else
    yield put(MessageActions.showMessage('Algo salió mal en la elminación de la orden', true));
}

function* changeOrderStatus({ order, incomingStatus }) {
  try {
    yield put(AuthActions.showAuthLoader())
    const { status: prevStatus } = order;
    const { user: { id: userId } } = yield select( state => state.user);
    // yield call(changeOrderStatusRequest, orderId, targetId, id, incomingStatus);
    yield call(changeOrderStatusRequest(order, userId, incomingStatus));
    yield put(OrdersActions.getOrders(prevStatus))
  } catch (error) {
    console.log("changeOrderStatus Error: ", error);
  }
}

export function* getOrdersWatcher() {
  yield takeLatest(OrdersTypes.GET_ORDERS, getOrders);
}

export function* addOrderWatcher() {
  yield takeLatest(OrdersTypes.ADD_ORDER, addOrder);
}

export function* deleteOrderWatcher() {
  yield takeLatest(OrdersTypes.DELETE_ORDER, deleteOrder);
}

export function* changeOrderStatusWatcher() {
  yield takeLatest(OrdersTypes.CHANGE_ORDER_STATUS, changeOrderStatus)
}

export default function* rootSaga() {
  yield all([
    fork(getOrdersWatcher),
    fork(addOrderWatcher),
    fork(deleteOrderWatcher),
    fork(changeOrderStatusWatcher)
  ]);
}